import React from 'react';
import { useMatchMakingStore } from './store';
import {
  Button,
  Stack,
  Typography,
  useMediaQuery,
  useTheme,
} from '@mui/material';
import { useIntl } from 'react-intl';
import translations from 'utils/translations';
import WhiteCard from './WhiteCard';

const UserList = ({ onCreate, handleDeleteUser, handleResetUserPassword }) => {
  const intl = useIntl();
  const i18n = translations.MatchMakingV2(intl).USERS;
  const theme = useTheme();
  const isSmDown = useMediaQuery(theme.breakpoints.down('sm'));
  const [users, currentProfile, loggedUser] = useMatchMakingStore((state) => [
    state.users,
    state.currentProfile,
    state.loggedUser,
  ]);
  const extraMatchmaking = loggedUser.services['Utenze Matchmaking Extra'];

  return (
    <>
      {/* <Stack
        flexDirection={isSmDown ? 'column' : 'row'}
        alignItems={'center'}
        justifyContent={'space-between'}
        gap={'20px'}
      >
        <Stack gap={'5px'}>
          {currentProfile.maxUsers === users?.length ? (
            <Typography
              variant="body2"
              textAlign={isSmDown ? 'center' : 'start'}
            >
              {i18n.subtitleMax}
            </Typography>
          ) : (
            <Typography
              variant="body2"
              textAlign={isSmDown ? 'center' : 'start'}
            >
              {i18n.stillCreate}{' '}
              <Typography variant="body1-bold">
                {currentProfile.maxUsers - users?.length}
              </Typography>{' '}
              {i18n.subtitleUsers}
            </Typography>
          )}
        </Stack>
        {currentProfile.maxUsers === users?.length ? null : (
          <Button
            variant="contained"
            color="primary"
            size="small"
            onClick={() => onCreate?.()}
            sx={{
              ...(isSmDown && {
                width: '100%',
              }),
            }}
          >
            {i18n.buttons.create}
          </Button>
        )}
      </Stack> */}
      <Stack
        flexDirection={isSmDown ? 'column' : 'row'}
        alignItems={'center'}
        justifyContent={'space-between'}
        gap={'20px'}
      >
        <Stack gap={'5px'}>
          {extraMatchmaking === users?.length ? (
            <Typography
              variant="body"
              textAlign={isSmDown ? 'center' : 'start'}
            >
              {i18n.subtitleMax}
            </Typography>
          ) : (
            <Stack gap={'10px'} flexDirection={'column'}>
              <Typography
                variant="subheadling"
                textAlign={isSmDown ? 'center' : 'start'}
                textTransform={'uppercase'}
                sx={{
                  fontWeight: 800,
                }}
              >
                {i18n.profile} {currentProfile.i18nLabel}
              </Typography>
              <Typography
                variant="body"
                textAlign={isSmDown ? 'center' : 'start'}
              >
                {i18n.stillCreate}{' '}
                <Typography
                  variant="body"
                  sx={{
                    fontWeight: 800,
                  }}
                >
                  {extraMatchmaking - users?.length}
                </Typography>{' '}
                {i18n.subtitleUsers}
              </Typography>
            </Stack>
          )}
        </Stack>
        {extraMatchmaking === users?.length ? null : (
          <Button
            variant="contained"
            color="primary"
            size="small"
            onClick={() => onCreate?.()}
            sx={{
              fontSize: '16px',
              lineHeight: '24px',
              ...(isSmDown && {
                width: '100%',
              }),
            }}
          >
            {i18n.buttons.create}
          </Button>
        )}
      </Stack>
      <Stack gap={'25px'}>
        {users.map((user, idx) => (
          <WhiteCard
            key={idx}
            entity={user}
            isReport={false}
            handleDelete={handleDeleteUser}
            handleReset={handleResetUserPassword}
          />
        ))}
      </Stack>
    </>
  );
};
export default UserList;
